// Rough estimate of the costs of selling a property in Ireland.
// Assumptions (adjust as needed):
//   - Estate agent: 1.5% of sale price + 23% VAT
//   - Solicitor (conveyancing): €2,000 + 23% VAT
//   - BER certificate: €250
//   - Marketing / advertising: €750
// Not included: Capital Gains Tax (not due on a principal private residence), mortgage early-redemption
// fees, and property tax/charges arrears.
export const IRISH_SELLING_COST_ASSUMPTIONS = {
    agentRate: 0.015,
    legalFee: 2000,
    vatRate: 0.23,
    berCert: 250,
    marketing: 750,
};

export function estimateSellingCosts(salePrice, assumptions = IRISH_SELLING_COST_ASSUMPTIONS) {
    if (!salePrice || salePrice <= 0) {
        return {total: 0, breakdown: []};
    }
    const {agentRate, legalFee, vatRate, berCert, marketing} = assumptions;
    const breakdown = [
        {label: `Estate agent (${(agentRate * 100).toFixed(1)}% + VAT)`, amount: salePrice * agentRate * (1 + vatRate)},
        {label: 'Solicitor (incl. VAT)', amount: legalFee * (1 + vatRate)},
        {label: 'BER certificate', amount: berCert},
        {label: 'Marketing', amount: marketing},
    ].map(item => ({...item, amount: Math.round(item.amount)}));
    return {
        total: breakdown.reduce((acc, item) => acc + item.amount, 0),
        breakdown,
    };
}
